import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, Input, FormGroup } from "reactstrap";
import { getOrderTotalAmount } from "store/actions/athleteAction";
import {
  getChatTotalAmount,
  getGroupChatTotalAmount,
} from "store/actions/athleteAction";
import { getFanRegistrationTotal } from "store/actions/athleteAction";
import { getLicenseTotalAmount } from "store/actions/athleteAction";
import { getRegistrationTotal } from "store/actions/athleteAction";
import { getAthlete } from "store/actions/athleteAction";

const AthletesCalculate = () => {
  const infoPoints = [
    "The admin reviews the platform's annual earnings from the FHP platform, including Chat, Group Chat, Badge Sales, Fan Registrations, Store Sales, and the Total Revenue.",
  ];
  const subPoints = [];
  const infoTitle = "Athlete Annual Earnings Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const dispatch = useDispatch();
  let {
    registrationTotal,
    chatTotal,
    groupChatTotal,
    licenseTotal,
    fanRegistrationTotal,
    orderTotal,
  } = useSelector((state) => state.athlete);
  const [year, setYear] = useState("");
  useEffect(() => {
    dispatch(getAthlete());
  }, []);
  useEffect(() => {
    if (year != "") {
      dispatch(getRegistrationTotal(year));
      dispatch(getChatTotalAmount(year));
      dispatch(getGroupChatTotalAmount(year));
      dispatch(getLicenseTotalAmount(year));
      dispatch(getFanRegistrationTotal(year));
      dispatch(getOrderTotalAmount(year));
    }
  }, [year]);
  let total =
    // registrationTotal +
    groupChatTotal +
    chatTotal +
    licenseTotal +
    fanRegistrationTotal +
    orderTotal;
  return (
    <>
      <Header />
      <Container className="mb-5" fluid>
        <Row className="d-flex justify-content-center align-items-center">
          <Col lg={4} sm={6} align="center">
            <FormGroup>
              <Input
                id="exampleSelect"
                name="select"
                type="select"
                value={year}
                onChange={(event) => setYear(event.target.value)}
              >
                <option>select a year</option>
                <option>2025</option>
                <option>2024</option>
                <option>2023</option>
                <option>2022</option>
                <option>2021</option>
                <option>2020</option>
                <option>2019</option>
                <option>2018</option>
              </Input>
            </FormGroup>
          </Col>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Row className="justify-content-center ">
          {/* <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${registrationTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from Registrations of Athletes
              </p>
            </div>
          </Col> */}

          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${chatTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from paid chat
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${groupChatTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from paid group chat
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${licenseTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from badge sales
              </p>
            </div>
          </Col>

          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${fanRegistrationTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from Registration of Fans
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${orderTotal.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">
                Dollars in year earned from Store sales
              </p>
            </div>
          </Col>
          <Col lg={4} sm={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers--calculateathlete">
                ${total.toFixed(2)}
              </p>
              <p className="dashboard-card-title--calculateathlete">Total</p>
            </div>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default AthletesCalculate;
